import { FormControl } from "@angular/forms";

export interface Ipv6464xlat {
    Active: string;
    Auto: string;
    DstPrefix: string;
    DstPrefixLen: number;
    SrcPrefix?: string;
    SrcPrefixLen?: number;
};

export interface Ipv6464xlatForm {
    Active: FormControl<string>;
    Auto: FormControl<string>;
    DstPrefix: FormControl<string>;
    DstPrefixLen: FormControl<number>;
    SrcPrefix?: FormControl<string>;
    SrcPrefixLen?: FormControl<number>;
};